/*********************** Custom JS for Boost AI Search & Discovery  ************************/


$(document).ready(function() {
   setTimeout(function() {
       var $element = $(".boost-sd__sorting-label");
       if ($element.length) {
           $element.html("Sort By");
       } else {
           console.log("Element not found");
       }
   }, 1000); // Adjust the delay as needed
});



$(document).ready(function() {
   // console.log('Boost JS File loaded....');

   $(".boost-sd__sorting-label").html("Sort By");
   $(".boost-sd__sorting-label").html("Custom Boost Heading");

   // alert("Boost Collection page...");
   // alert($(".boost-sd__sorting-label").text());

   var sortlabel = $('.boost-sd__sorting-label-wrapper .boost-sd__sorting-label').text();

   var arslan = $(".boost-sd__sorting-label");

   console.log("Boost 1:  " + $('.boost-sd__sorting-label-wrapper .boost-sd__sorting-label').text());
   console.log("Boost 2:  " + $(".boost-sd__sorting-label").html());
   console.log("Boost 3:  " + $(".boost-sd__sorting-label"));
   console.log("Boost 4:  " + sortlabel);
   console.log("Boost ARSLAN 1 :  " + arslan[0]);
   console.log("Boost ARSLAN 2 :  " + arslan[0].innerHTML);


   // let headingElements =  document.getElementsByClassName('boost-sd__sorting-label');
   // console.log("Boost 5:  " + headingElements);

   var elements = document.getElementsByClassName('boost-sd__sorting-label');
      console.log(elements[0].innerHTML); // Accesses the first element's text content


});


   if (window.boostSDAppConfig) {

      window.boostSDAppConfig.integration =  Object.assign({

      wishlists: 'i-wishlist'

      }, window.boostSDAppConfig.integration || {});
   }


   if(boostSDAppConfig?.filterSettings) {
      boostSDAppConfig.filterSettings.filterLayout = 'horizontal';
      boostSDAppConfig.filterSettings.requestInstantly = true;
   }

   const customize = {
      moveHeaderDescription: (componentRegistry) => {
        componentRegistry.useComponentPlugin("FilterTree", {
          name: "Move Collection Description Below Product List",
          apply: () => {

             return {
                afterRender(element) {
                   try {
                      const filterTree = element.getRootElm();
                      console.log(filterTree)
                      if(document.querySelector(".boost-sd__toolbar-item--view-as")){
                        document.querySelector(".boost-sd__toolbar-item--view-as").insertAdjacentElement("afterend", filterTree)

                      }

                   } catch (err) {
                      console.warn(err);
                   }
                }
             }
          }
       })
      },

      updateProductItemGrid: (componentRegistry) => {
          componentRegistry.useComponentPlugin('ProductItem', {
             name: 'Add extra information',
             enabled: true,
             apply: () => ({
                afterRender(element) {
                   try {
                      // Start customization--------------------------------------------
                      let productData = element.getParams().props.product;
                      let productId = productData.id;
                      if (productData?.split_product) {
                         productId = productData.variant_id;
                      }
                      let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                      if (productItem) {
                         /* use pure js here */
                         /* Example - Add percent sale info */
                         if (productData?.percent_sale_min > 0) {
                            const percentSaleHtml = `<div class="discount-price" style="letter-spacing: .2em; text-transform: uppercase;">
                            <span class="text-svg">  <svg width="23px" height="18px" viewBox="0 0 23 18" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="a7bd6c3c-ffc4-473c-bc2b-f91493cc0cb3"><title id="a7bd6c3c-ffc4-473c-bc2b-f91493cc0cb3">Sale Tag</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(0.000000, -3.500000)" fill="#BF2E35"><g transform="translate(11.500000, 12.500000) rotate(-360.000000) translate(-11.500000, -12.500000) translate(0.000000, 4.000000)"><path d="M15.5999997,-8.8817842e-15 C16.4039997,-8.8817842e-15 17.1239997,0.395999993 17.5559997,1.00799998 L17.5559997,1.00799998 L22.7999996,8.39999986 L17.5559997,15.7919997 C17.1239997,16.4039997 16.4039997,16.7999997 15.5999997,16.7999997 L15.5999997,16.7999997 L2.39999996,16.7879997 C1.07999998,16.7879997 -1.28785871e-12,15.7199997 -1.28785871e-12,14.3999998 L-1.28785871e-12,14.3999998 L-1.28785871e-12,2.39999996 C-1.28785871e-12,1.07999998 1.07999998,0.0119999998 2.39999996,0.0119999998 L2.39999996,0.0119999998 Z M16.8487322,6.85714286 C15.9019584,6.85714286 15.1344465,7.62465471 15.1344465,8.57142857 C15.1344465,9.51820243 15.9019584,10.2857143 16.8487322,10.2857143 C17.7955061,10.2857143 18.5630179,9.51820243 18.5630179,8.57142857 C18.5630179,7.62465471 17.7955061,6.85714286 16.8487322,6.85714286 Z"></path></g></g></g></svg> </span>
                            <span class="off-text">${productData.percent_sale_min}% Off</span>
                           </div>`;
                            if (!productItem.querySelector('.discount-price')) {
                               productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('beforebegin', percentSaleHtml);
                            }
                         }
                          /* End example */
                      }
                      // End-------------------------------------------------------------
                   } catch (e) {
                      console.warn(e);
                   }
                }
             }),
          });
      }
   }

   window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.moveHeaderDescription, customize.updateProductItemGrid]);